import { ModalSelecaoParceiroDashboardMassaStyles } from './ModalSelecaoParceiroDashboardMassa.styles'

export function ModalSelecaoParceiroDashboardMassaIO() {
  return {
    styles: ModalSelecaoParceiroDashboardMassaStyles
  }
}

export type ModalSelecaoParceiroDashboardMassaIO = ReturnType<typeof ModalSelecaoParceiroDashboardMassaIO>
